class Tabs {
    constructor(element) {
        Object.defineProperty(this, "tabs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tabsTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tabsContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tabsMobileTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tabs = element;
        this.tabsTrigger = this.tabs.querySelectorAll('.single-tab-trigger');
        this.tabsContent = this.tabs.querySelectorAll('.single-tab-content');
        this.tabsMobileTrigger = this.tabs.querySelectorAll('.tabs-mobile-trigger');
    }
    init() {
        for (const element of this.tabsTrigger) {
            element.addEventListener('click', (event) => {
                const clicked = event.target;
                if (clicked.classList.contains('active')) {
                    return;
                }
                const tab = clicked.dataset.tab;
                if (tab)
                    this.switchTab(tab);
            });
        }
        for (const element of this.tabsMobileTrigger) {
            element.addEventListener('click', (event) => {
                const clicked = event.target;
                let desire = 0;
                for (const [index, triggerElement] of [...this.tabsTrigger].entries()) {
                    if (triggerElement.classList.contains('active')) {
                        desire = index;
                    }
                }
                if (clicked.classList.contains('prev-tab')) {
                    desire = desire === 0 ? this.tabsTrigger.length - 1 : desire - 1;
                }
                else {
                    desire = desire === this.tabsTrigger.length - 1 ? 0 : desire + 1;
                }
                const tab = this.tabsTrigger.item(desire).dataset.tab;
                if (tab)
                    this.switchTab(tab);
            });
        }
    }
    switchTab(tab) {
        for (const element of this.tabsTrigger) {
            element.classList.remove('active');
            if (element.dataset.tab === tab) {
                element.classList.add('active');
            }
        }
        for (const element of this.tabsContent) {
            jQuery(element).stop().fadeOut(300);
            element.classList.remove('active');
            if (element.dataset.tab === tab) {
                jQuery(element).stop().fadeIn(300);
                element.classList.add('active');
            }
        }
    }
}
export default function tabs() {
    const tabs = document.querySelectorAll('.block-tabs');
    for (const element of tabs) {
        const tabsElement = new Tabs(element);
        tabsElement.init();
    }
}
